import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum NtakMarketSegmentId {
  LEISURE_INDIVIDUAL = 1,
  LEISURE_GROUP = 2,
  BUSINESS_INDIVIDUAL = 3,
  BUSINESS_GROUP = 4,
  UNKNOWN = 5,
}

export class NtakMarketSegment extends Codebook<NtakMarketSegmentId> {
  static readonly LEISURE_INDIVIDUAL = new NtakMarketSegment(
    NtakMarketSegmentId.LEISURE_INDIVIDUAL,
    () => $t('Single reservation for leisure'),
  )

  static readonly LEISURE_GROUP = new NtakMarketSegment(NtakMarketSegmentId.LEISURE_GROUP, () =>
    $t('Group reservation for leisure'),
  )

  static readonly BUSINESS_INDIVIDUAL = new NtakMarketSegment(
    NtakMarketSegmentId.BUSINESS_INDIVIDUAL,
    () => $t('Single reservation, business'),
  )

  static readonly BUSINESS_GROUP = new NtakMarketSegment(NtakMarketSegmentId.BUSINESS_GROUP, () =>
    $t('Group reservation, business'),
  )

  static readonly UNKNOWN = new NtakMarketSegment(NtakMarketSegmentId.UNKNOWN, () =>
    $t('Unknown purpose of reservation, type'),
  )

  private constructor(
    public readonly id: NtakMarketSegmentId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
